import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)
const Store = new Vuex.Store({
    state: {
        activeMenu: '/index',
        goBack: '',
        errowType: '',
        errowUrl: '',
        showCircle:false,
    },
    mutations: {
        setActiveMenu(state, data) {
            state.activeMenu = data
        },
        setGoBack(state, data) {
            state.goBack = data
        },
        getType(state, data) {
            state.errowType = data;
        },
        getUrl(state, data) {
            state.errowUrl = data;
        },
        getShowCircle(state,data){
            state.showCircle = data
        }

    }
})
export default Store


// WEBPACK FOOTER //
// ./src/store/module.js